import { seoSections } from '@/mocks/categories';

export default function HowItWorksSection() {
  const { howItWorks } = seoSections;

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-sm font-semibold text-primary-500 uppercase tracking-wider mb-3">Proces</p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            {howItWorks.title}
          </h2>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-[10%] right-[10%] h-0.5 bg-background-200 -translate-y-1/2"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 relative">
            {howItWorks.steps.map((step, index) => (
              <div
                key={step.number}
                className="relative flex flex-col items-center text-center p-5"
                style={{ animation: `fadeInUp 0.5s ease-out ${index * 0.1}s both` }}
              >
                <div className="w-14 h-14 rounded-full bg-primary-500 flex items-center justify-center mb-4 relative z-10 shadow-sm">
                  <span className="text-background-50 font-bold text-lg">{step.number}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{step.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}